export const SET_DATA = 'mp/dataProvider/SET_DATA';
export const NORMALIZE_DATA = 'mp/dataProvider/NORMALIZE_DATA';

export const normalizeData = (key, data, meta) => {
  return {
    type: NORMALIZE_DATA,
    key,
    data,
    meta
  };
};

export const setData = (key, payload) => {
  return {
    type: SET_DATA,
    key,
    payload
  };
};

export const getKeyedData = (stateKey, actionKey, actionData) => {
  return stateKey !== actionKey ? null : {
    loaded: true,
    ...actionData
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/dataProvider/dataProvider.js
 **/